/* unplugin-vue-components disabled */import { render } from "./UserSex.vue?vue&type=template&id=d7fcf176&scoped=true"
import script from "./UserSex.vue?vue&type=script&lang=js"
export * from "./UserSex.vue?vue&type=script&lang=js"

import "./UserSex.vue?vue&type=style&index=0&id=d7fcf176&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7fcf176"]])

export default __exports__